import { useCallback, useEffect, useState } from 'react'

export function useSidePanelNavCollapse(storageKey: string) {
  const [isCollapsed, setIsCollapsed] = useState(false)

  useEffect(() => {
    try {
      setIsCollapsed(window.localStorage.getItem(storageKey) === '1')
    } catch {
      setIsCollapsed(false)
    }
  }, [storageKey])

  const toggleCollapse = useCallback(() => {
    setIsCollapsed((current) => {
      const next = !current

      try {
        window.localStorage.setItem(storageKey, next ? '1' : '0')
      } catch {
        // Ignore storage failures.
      }

      return next
    })
  }, [storageKey])

  return { isCollapsed, toggleCollapse }
}
